import { render, staticRenderFns } from "./output.vue?vue&type=template&id=05cffab6&"
import script from "./output.vue?vue&type=script&lang=js&"
export * from "./output.vue?vue&type=script&lang=js&"
import style0 from "./output.vue?vue&type=style&index=0&id=05cffab6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports